var _a, _b, _c, _d;
import { __decorate, __metadata, __param } from "tslib";
import { SaveCustomFieldAsPublicService } from '@/domains/custom-fields/services/save-custom-field-as-public-service.interface';
import { ConfirmService } from '@/services/confirm-service.interface';
import { I18nService } from '@/services/i18n-service';
import { Message } from '@patsnap/tahiti-core/common/message';
import { inject, injectable } from 'inversify';
let SaveCustomFieldAsPublicCommandContribution = class SaveCustomFieldAsPublicCommandContribution {
    constructor(_i18nService, _saveCustomFieldAsPublicService, _confirmService, _message) {
        this._i18nService = _i18nService;
        this._saveCustomFieldAsPublicService = _saveCustomFieldAsPublicService;
        this._confirmService = _confirmService;
        this._message = _message;
    }
    registerCommands(commands) {
        commands.registerCommand({
            id: 'custom-field.save-as-public',
            icon: 'SolidCopy',
            label: this._i18nService.t('customField.actions.copyToPublic'),
        }, {
            execute: (context) => {
                return this._execute(context);
            },
        });
    }
    async _execute(context) {
        const confirm = await this._confirmService.confirm({
            title: this._i18nService.t('publicField.copyTitle'),
            message: this._i18nService.t('publicField.copyDesc'),
            confirmText: this._i18nService.t('global.btn.confirm'),
            cancelText: this._i18nService.t('global.btn.cancel'),
            type: 'info',
        });
        if (!confirm) {
            return;
        }
        this._saveCustomFieldAsPublicService.saveAsCompanyCustomField(context.fields);
        this._message.success({
            message: this._i18nService.t('publicField.copySuccess'),
        });
    }
};
SaveCustomFieldAsPublicCommandContribution = __decorate([
    injectable(),
    __param(0, inject(I18nService)),
    __param(1, inject(SaveCustomFieldAsPublicService)),
    __param(2, inject(ConfirmService)),
    __param(3, inject(Message)),
    __metadata("design:paramtypes", [typeof (_a = typeof I18nService !== "undefined" && I18nService) === "function" ? _a : Object, typeof (_b = typeof SaveCustomFieldAsPublicService !== "undefined" && SaveCustomFieldAsPublicService) === "function" ? _b : Object, typeof (_c = typeof ConfirmService !== "undefined" && ConfirmService) === "function" ? _c : Object, typeof (_d = typeof Message !== "undefined" && Message) === "function" ? _d : Object])
], SaveCustomFieldAsPublicCommandContribution);
export { SaveCustomFieldAsPublicCommandContribution };
